import { generateTestId } from "@client-shared";

export const setProtectedRouteTestId = (identifier: string): string => generateTestId("ProtectedRoute", identifier);
